import PropTypes from "prop-types";
import React from "react";
import {Col, Container, Row} from "reactstrap";

// Pages Components
import LatestTranaction from "./Alert";


//i18n
import {withTranslation} from "react-i18next";

const Threshold = props => {

  document.title = "Alert | Temperstack";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>
            <Col lg="12">
              <LatestTranaction/>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Threshold.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Threshold);
